import { SkipContentButton } from 'components/buttons/SkipContentButton';
import { EndFocus } from 'components/buttons/EndFocus';
import { SecondaryButton } from 'components/buttons/v4';
import { ContentSection, PageContainer, PageTitle, TitleSection } from 'core/layout';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { MutableRefObject, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AnalyticsService } from 'utils/AnalyticsService';
import { ContentIntelligenceTable } from './ContentIntelligenceTable';

export const ContentIntelligencePage = () => {
  const { t } = useTranslation();
  const endFocusRef: MutableRefObject<HTMLDivElement | null> = useRef(null);

  useEffect(() => {
    AnalyticsService.getInstance().track('content_intelligence_page_viewed');
  }, []);

  useDocumentTitle(t('Content Intelligence'));

  return (
    <MainFrame>
      <PageContainer>
        <TitleSection>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <PageTitle>{t('Content Intelligence')}</PageTitle>
            <SkipContentButton endFocusRef={endFocusRef} />
          </div>
          <Link to="/nav/content" style={{ textDecoration: 'none' }}>
            <SecondaryButton click={() => {}}>{t('Back to Content')}</SecondaryButton>
          </Link>
        </TitleSection>
        <ContentSection style={{ paddingBottom: '48px' }}>
          <ContentIntelligenceTable />
          <EndFocus endFocusRef={endFocusRef} />
        </ContentSection>
      </PageContainer>
    </MainFrame>
  );
};

const MainFrame = styled.div`
  height: 100vh;
  display: flex;
  flex-grow: 1;
  border: none;
`;
